<template>
  <div>
    <div class="my-4">
      <v-checkbox
        :label="`${lead.firstname}, it takes 3-5mins to send your info
          to the underwriters, from there the underwriters take 24-48hrs to medically
          approve you. Because you told me you need this protection for:`"
      />

      <div class="d-flex justify-center my-4 body-1">
        <ul>
          <li>{{ beneficiaryDetails }}</li>

          <li v-for="(type, k) in needsList" :key="k">
            {{ needTextByType(type, needs[type]) }}
          </li>

          <li v-for="(key, k) in selectedDisease" :key="key + k">
            {{ diseaseDetails(key) }}
          </li>
        </ul>
      </div>

      <div class="d-flex align-center justify-space-between">
        <div>
          I'm going to work with the underwriters, What email address should we
          use on file?
        </div>
        <v-btn color="primary">
          Apply for this product
          <v-icon right dark> mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="my-4">
      <v-checkbox
        label="To make an advised decision, we have got you medically
            underwritten. Because you have:"
      />

      <!--  health history   -->

      <div class="d-flex justify-center my-4 body-1">
        <ul>
          <li v-for="(key, k) in selectedDisease" :key="k">
            {{ diseaseDetails(key) }}
          </li>
        </ul>
      </div>

      <div>
        We have to get you approved and with that approval you'll be able to
        make a more advised decision. I'm going to see if I can get you
        approved, is this the correct spelling your name?
      </div>

      <div class="d-flex my-4 justify-center">
        <v-btn color="primary">
          Apply for this product
          <v-icon right dark> mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="my-4">
      <v-checkbox
        :label="`Based on everything you told me the ${lead.total_income} is the
            perfect amount of coverage because you told me:`"
      />

      <div class="d-flex justify-center my-4 body-1">
        <ul>
          <li>{{ beneficiaryDetails }}</li>
          <li v-for="(type, k) in needsList" :key="k">
            {{ needTextByType(type, needs[type]) }}
          </li>
        </ul>
      </div>

      <h4>And you have:</h4>

      <div class="d-flex justify-center my-4 body-1">
        <ul>
          <li v-for="(key, k) in selectedDisease" :key="k">
            {{ diseaseDetails(key) }}
          </li>
        </ul>
      </div>

      <p>
        You can't make a bed decision, we help thousands of people every month!
        This is an A rated carrier, has some of the highest value products on
        the market, It's backend with a 30Day money back guarantee. If we can
        get you approved, I know you'll be happy.
      </p>

      <div class="d-flex justify-space-between align-center">
        I want to help you with this. What's you middle initial?

        <v-btn color="primary">
          Apply for this product
          <v-icon right dark> mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { diseaseTextByType, needTextByType } from '@/common/helpers';

export default {
  name: 'QuotesRebuttal',
  props: {
    lead: Object,
    beneficiary: Object,
  },
  computed: {
    ...mapGetters({
      disease: 'plates/disease',
      selectedDisease: 'plates/selectedDisease',
      baseData: 'baseData/baseData',
      needs: 'plates/needs',
      needsList: 'plates/needsList',
    }),
    beneficiaryDetails() {
      const isLiveInSameState = this.beneficiary.liveInSameState
        ? `Leaves in ${this.lead.state}`
        : 'Leaves out of state';

      const isAnyGrandchildren = this.beneficiary.grandchildrenAmount
        ? `- ${this.beneficiary.grandchildrenAmount} Grandkids`
        : '';

      const nonSpouseText =
        this.beneficiary.relationship !== 'spouse'
          ? `- ${isLiveInSameState} ${isAnyGrandchildren}`
          : '';

      return `${this.beneficiary.relationship} - ${this.beneficiary.name} ${nonSpouseText}`;
    },
  },
  methods: {
    diseaseDetails(type) {
      return diseaseTextByType(type, this.disease[type]);
    },
    needTextByType,
  },
};
</script>